import styled from 'styled-components';

export const Header = styled.div`
  display: flex;
  justify-content: space-between;

  .subHeader {
    display: flex;
    gap: 1rem;
    align-items: center;

    h1 {
      color: ${({ theme }) => theme.colors.secondary};
      font-size: 1.3rem;
      margin: 0;
      font-weight: 500;
    }
  }

  .close-div {
    padding: 0;
    height: 10px;
    button {
      color: ${({ theme }) => theme.colors.background_white};
      background-color: ${({ theme }) => theme.colors.tertiary_500};
      width: 20px;
      height: 19px;
      border-radius: 100%;
      padding: 0;
      border: none;

      :hover {
        cursor: pointer;
      }
    }
  }
`;

export const ContentModal = styled.div`
  margin-top: 0.5rem;
  margin-left: 0.2rem;
  height: 60vh;
  overflow-y: auto;
  color: ${({ theme }) => theme.colors.text};
  font-size: 0.875rem;
  font-weight: 300;

  h1 {
    font-size: 1.5rem;
    font-weight: 500;
    margin-top: 0.5rem;
  }
  h2 {
    font-size: 1.2rem;
    font-weight: 500;
  }
  strong {
    font-size: 0.875rem;
    font-weight: 500;
  }

  p {
    margin-top: 0.25rem;
    text-indent: 1rem;
  }

  ol li {
    list-style-type: lower-alpha;
  }

  div ol li {
    list-style-type: lower-roman;
  }
`;

export const ContentModalButton = styled.div`
  .containerButton {
    margin-top: 1rem;
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;
